import { createAsyncTypes } from 'utils/ActionCreator'

const typeKey = 'AwarenessCenter/Campaigns'

export const CAMPAIGN_TYPE_FILTER_CHANGE = `${typeKey}/CAMPAIGN_TYPE_FILTER_CHANGE`
export const LANGUAGES_FILTER_CHANGE = `${typeKey}/LANGUAGES_FILTER_CHANGE`
export const STATUS_FILTER_CHANGE = `${typeKey}/STATUS_FILTER_CHANGE`
export const DATE_FILTER_CHANGE = `${typeKey}/DATE_FILTER_CHANGE`
export const PAGINATE_CHANGE = `${typeKey}/PAGINATE_CHANGE`
export const SEARCH_CHANGE = `${typeKey}/SEARCH_CHANGE`
export const SORT_PROPERTY_CHANGE = `${typeKey}/SORT_PROPERTY_CHANGE`
export const SET_RECOMMENDED_PREVIEW_DATA = `${typeKey}/SET_RECOMMENDED_PREVIEW_DATA`
export const RESET_RECOMMENDED_PREVIEW_DATA = `${typeKey}/RESET_RECOMMENDED_PREVIEW_DATA`
export const RESET_FILTERS = `${typeKey}/RESET_FILTERS`
export const CHANGE_SELECTION_DATA = `${typeKey}/CHANGE_SELECTION_DATA`

export const DATA_REQUEST_ASYNC = createAsyncTypes('DATA_REQUEST', typeKey)
export const COPY_CAMPAIGN_ASYNC = createAsyncTypes(`${typeKey}/COPY_CAMPAIGN_ASYNC`)
export const CANCEL_CAMPAIGN_ASYNC = createAsyncTypes(`${typeKey}/CANCEL_CAMPAIGN_ASYNC`)
export const END_CAMPAIGN_ASYNC = createAsyncTypes(`${typeKey}/END_CAMPAIGN_ASYNC`)
export const DELETE_CAMPAIGN_ASYNC = createAsyncTypes(`${typeKey}/DELETE_CAMPAIGN_ASYNC`)
export const GET_RECOMMENDED_CAMPAIGNS = createAsyncTypes(`${typeKey}/GET_RECOMMENDED_CAMPAIGNS`)
export const SAVE_DRAFT_ASYNC = createAsyncTypes('SAVE_DRAFT', typeKey)

export const CAMPAIGN_STATUS = {
  DRAFT: 0,
  COLLECTING: 1,
  CLOSED: 2,
  APPROVED: 3,
  SENDING: 4,
}
export const CAMPAIGN_STATUS_LABEL = {
  [CAMPAIGN_STATUS.DRAFT]: 'Draft',
  [CAMPAIGN_STATUS.COLLECTING]: 'Collecting',
  [CAMPAIGN_STATUS.CLOSED]: 'Closed',
  [CAMPAIGN_STATUS.APPROVED]: 'Approved',
  [CAMPAIGN_STATUS.SENDING]: 'Sending',
}
export const CAMPAIGN_STATUS_CHOICES = ['Draft', 'Collecting', 'Closed', 'Approved', 'Sending']
export const CAMPAIGN_TYPE_CHOICES = ['Multi Level', 'Single Level', 'Benchmark']
export const ALL_SELECTED_GROUP_NAME = 'All Selected Users'
export const RECOMMENDED_CAMPAIGN_START_HOURS = 10
export const RECOMMENDED_CAMPAIGN_DEFAULT_DURATION = 7
export const ORDER_MAP = {
  desc: 'asc',
  asc: 'desc',
}
